import { TanStackDevtools } from '@tanstack/react-devtools'
import { FormDevtoolsPlugin } from '@tanstack/react-form-devtools'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { Suspense, useEffect } from 'react'

import { LoadingScreen } from '@/components/block/common/loading-screen'
import { TailwindDevTools } from '@/components/tools/tailwind-dev-tools'

import { MediaQueryProvider } from '@/hook/use-media-query'
import { useUserPreference } from '@/hook/use-user-preference'
import { StoreProvider } from '@/lib/store'
import { queryClient } from '@/lib/tanstack-query'
import { createRouter } from '@/lib/tanstack-router'

const router = createRouter()

export function EntryApp() {
  const { theme } = useUserPreference()

  useEffect(() => {
    document.documentElement.classList.remove('light', 'dark', 'scheme-light', 'scheme-dark')
    document.documentElement.classList.add(theme)
    document.documentElement.classList.add(theme === 'dark' ? 'scheme-dark' : 'scheme-light')
  }, [theme])

  useEffect(() => {
    if (navigator.userAgent?.indexOf('iPhone') > -1) {
      document
        ?.querySelector('[name=viewport]')
        ?.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1')
    }
  }, [])

  return (
    <Suspense fallback={<LoadingScreen />}>
      <StoreProvider>
        <QueryClientProvider client={queryClient}>
          <MediaQueryProvider query='(min-width: 768px)'>
            <RouterProvider router={router} context={{ qc: queryClient }} />
            {import.meta.env.DEV && <DevTools />}
          </MediaQueryProvider>
        </QueryClientProvider>
      </StoreProvider>
    </Suspense>
  )
}

function DevTools() {
  return (
    <>
      <TailwindDevTools />
      <TanStackDevtools plugins={[FormDevtoolsPlugin()]} />
      {/* <TanStackRouterDevtools router={router} /> */}
    </>
  )
}
